import { AppState } from 'state/types';

import type { ModelVersionState } from './model-version-reducer';

const getViews = (state: any) => state.views;
const getModelRegistry = (state: any) => getViews(state).modelRegistry;

export const getModelVersionState = (state: AppState): ModelVersionState =>
  getModelRegistry(state).modelVersion;
